import { render } from "./IconShow2.vue?vue&type=template&id=9edb5564"
import script from "./IconShow2.vue?vue&type=script&lang=js"
export * from "./IconShow2.vue?vue&type=script&lang=js"

import exportComponent from "/home/developer/public_html/admin.cureline-crm.cureline.com/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__